/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("digiexam").
controller("UploadOfflineAnswerFileController", function UploadOfflineAnswerFileController(
	$scope,

	DX_UPLOAD_STATE,
	dxDialog,
	ExamRepository,
	dxLocalize
) {
	"use strict";

	$scope.invalidFiles = [];
	$scope.offlineAnswers = [];
	$scope.isDone = false;
	$scope.uploadControl = {};
	$scope.uploadUrl = "/exam/upload/" + $scope.examId + "/";

	$scope.uploadStatus = {
		StatusOK: "UploadStatus.HandedIn",
		StatusWrongExam: "UploadStatus.WrongExam",
		StatusInvalidEmail: "UploadStatus.InvalidEmail",
		StatusStudentNotFound: "UploadStatus.StudentNotFound",
	};

	$scope.DX_UPLOAD_STATE = DX_UPLOAD_STATE;

	$scope.onFileUploaded = function onFileUploaded(item, response) {
		for (var i = 0; i < response.length; i++) {
			var offlineAnswer = response[i];
			$scope.offlineAnswers.push(offlineAnswer);
		}

		if (item.isError && response && response.msgs && response.msgs[0] === "exam published") {
			item.errorMessage = "UploadOfflineAnswerFile_UnpublishToUpload";
		}
	};

	$scope.onCompleteAll = function onCompleteAll() {
		$scope.isDone = true;
		ExamRepository.load($scope.examId);

		if ($scope.$parent.hasOwnProperty("onCompleteAll")) {
			$scope.$parent.onCompleteAll();
		}
	};

	$scope.close = function close() {
		dxDialog.closeMostRecent();

		if ($scope.$parent.hasOwnProperty("onClose")) {
			$scope.$parent.onClose();
		}
	};

	$scope.uploadOfflineAnswerFileHelpUrl = function uploadOfflineAnswerFileHelpUrl() {
		if (dxLocalize.getLanguage() === "sv") {
			return "https://digiexam.zendesk.com/hc/sv/articles/115003702065-Ladda-upp-offlinesvarsfil";
		}

		return "https://digiexam.zendesk.com/hc/en-us/articles/115003702065-How-do-I-upload-an-offline-answer-file-";
	};
});
